import { Stack, Typography } from '@mui/material';

import { FSToggleButtonGroup } from '@/ui/components/button/FSToggleButtonGroup';
import { translate } from '@/ui/i18n';

export function Tabs() {
  const tabValues = [
    {
      id: 'SURVEY-MOBILITY-ACCOMMODATION',
      value: (
        <ToggleButtonValue
          text={translate('Surveys.ScopeNames.SURVEY-MOBILITY-ACCOMMODATION')}
        />
      ),
    },
  ];

  return (
    <FSToggleButtonGroup
      selectedValueId={tabValues[0].id}
      values={tabValues}
      onChange={() => {}}
    />
  );
}

function ToggleButtonValue({ text }: { text: string }) {
  return (
    <Stack direction={'row'} spacing={1}>
      <Typography sx={{ fontSize: '1rem' }}>{text}</Typography>
    </Stack>
  );
}
